import script from "./LoginWithGoogle.vue?vue&type=script&lang=js"
export * from "./LoginWithGoogle.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__